import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import Dish from './components/Dish';
import style from './Dishes.module.scss';

const Dishes: React.FC = () => {
	const { dishesForAssign } = useContext<IDishAssignmentContext>(DishAssignmentContext);

	return (
		<div className={style.container} data-test="Dishes">
			<div className={style.tableOfContents}>
				<Text
					className={style.name}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={style.categories}
					translationNameSpace="listing"
					translationKey="categoriesLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={style.subcategories}
					translationNameSpace="listing"
					translationKey="subcategoriesLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={style.externalId}
					translationNameSpace="listing"
					translationKey="externalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={style.price}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{dishesForAssign.dishes.map((el) => (
				<Dish data={el} key={el.id + 'dishesList'} />
			))}
		</div>
	);
};

export default Dishes;
